export const COLUMN_TITLE = 'Title';
export const COLUMN_DATE = 'Date';
export const COLUMN_SOURCE = 'Source';
export const COLUMN_SIZE = 'Size';
export const COLUMN_PRICE = 'Price Per Share';
export const COLUMN_WEIGHTING = 'Weighting';

export const SOURCE_ROWS_TABLE_TARGET_PRICE_TITLE = 'Target Price Per Share';

export const COLUMN_HEADERS = [
  COLUMN_DATE,
  COLUMN_SOURCE,
  COLUMN_SIZE,
  COLUMN_PRICE,
  COLUMN_WEIGHTING,
];

export const getColumnHeaders = (tableTitle: string): string[] => [tableTitle, ...COLUMN_HEADERS];

export const SOURCE_ROWS_TABLE_PRICE_COLUMN = 'E';
export const SOURCE_ROWS_TABLE_WEIGHTING_COLUMN = 'F';

export const NUM_COLUMNS = COLUMN_HEADERS.length + 1;

export const SOURCE_ROWS_TABLE_HEADER_ROW = 1;
export const SOURCE_ROWS_TABLE_OFFSET = 2;

export const SOURCE_ROWS_TABLE_TITLE_INDEX = 0;
export const SOURCE_ROWS_TABLE_DATE_INDEX = 1;
export const SOURCE_ROWS_TABLE_SOURCE_INDEX = 2;
export const SOURCE_ROWS_TABLE_SIZE_INDEX = 3;
export const SOURCE_ROWS_TABLE_PRICE_INDEX = 4;
export const SOURCE_ROWS_TABLE_WEIGHTING_INDEX = 5;
